import { useCheckoutSubmitBumbalDate } from "app/hooks/checkout/useCheckoutSubmitBumbalDate";
import { useDeleteOrder } from "app/hooks/checkout/useDeleteOrder";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { useSearchParams } from "react-router-dom";
import { STORAGE_ORDER_KEY, STORAGE_PAYMENT_URL } from "shared/config";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutDoorAppointmentFooterProps {
  selectedDate: Date | null;
  planAppointmentLater: boolean;
}

const CheckoutDoorAppointmentFooter = ({
  selectedDate,
  planAppointmentLater,
}: CheckoutDoorAppointmentFooterProps) => {
  const { submitBumbalDate, isCreatingBumbalDate } =
    useCheckoutSubmitBumbalDate();
  const { isSampleSale, containsZakelijkProducts } = useCartContext();
  const { order } = useOrderContext();
  const { onMeasurementAppointment } = useAnalytics();
  const { updateCurrentTab } = useCheckoutTabsContext();

  const buttonText = isSampleSale ? "Betalen" : "Bevestigen";

  const { deleteOrderMutation } = useDeleteOrder();

  const [searchParams, setSearchParams] = useSearchParams();

  const canProceed = () => {
    return !(!!selectedDate || planAppointmentLater);
  };

  const goToNextStep = () => {
    let schedulingMoment = "";
    if (selectedDate) schedulingMoment = "Direct";
    if (planAppointmentLater) schedulingMoment = "At a later moment";

    onMeasurementAppointment(order!, schedulingMoment);

    submitBumbalDate(selectedDate, planAppointmentLater);

    //On sample sale or business flow, go to payment tab
    if (isSampleSale || containsZakelijkProducts) {
      updateCurrentTab(CheckoutTabIds.PAYMENT);
    }
  };

  const onGoToPrevTabClick = () => {
    if (searchParams.get("reference")) {
      // Get the order ID from the query params
      const orderId = searchParams.get("reference") ?? "";

      // Delete the order
      deleteOrderMutation(orderId);
    }
    // Remove the reference and type query params
    searchParams.delete("reference");
    searchParams.delete("type");
    setSearchParams(searchParams);

    // Remove the order ID and payment URL from local storage
    localStorage.removeItem(STORAGE_ORDER_KEY);
    localStorage.removeItem(STORAGE_PAYMENT_URL);

    // Go back to the previous tab (Personal Info)
    updateCurrentTab(CheckoutTabIds.PERSONAL_INFO);
  };

  return (
    <footer
      className={concatClassnames(
        "gg-px-4 sm:gg-px-14",
        "gg-flex gg-justify-between gg-gap-x-8 gg-gap-y-5 gg-bg-dark-blue gg-py-11 gg-text-white",
      )}
    >
      <Button
        onClick={() => onGoToPrevTabClick()}
        type={ButtonTypes.WHITE}
        arrow={ButtonArrowTypes.LEFT}
        className="gg-flex gg-w-48 gg-items-center gg-justify-center gg-justify-self-end gg-whitespace-nowrap gg-py-3 xl:gg-py-3.5"
      >
        Terug
      </Button>
      <Button
        type={ButtonTypes.YELLOW}
        arrow={ButtonArrowTypes.RIGHT}
        onClick={goToNextStep}
        className="gg-flex gg-w-48 gg-items-center gg-justify-center gg-px-6 gg-py-3"
        disabled={canProceed() || isCreatingBumbalDate}
        loading={isCreatingBumbalDate}
      >
        {buttonText}
      </Button>
    </footer>
  );
};
export default CheckoutDoorAppointmentFooter;
